import {enumToObject} from './enumToObject';

export const enumToValues = <T extends object>(enumObject: T) =>
	Object.values(enumToObject(enumObject)) as T[keyof T][];
